import React from 'react';
import { Img, Icon, Button } from 'components';
import { Section, Box, Text } from 'styles';

export function Section5(props) {
  return (
    <Section>
      <Box $maxWidth={1600} $padding="80px 40px" $mPadding="40px 20px" $margin="auto">
        <Box $width="fit-content" $margin="auto">
          <Button $type="badge">
            <Icon name="badgeIcon" />
            Use case
          </Button>
        </Box>
        <Text $type="b40" $mType="b28" $padding="24px 0 16px" $textAlign="center">
          N-Survey 활용 사례
        </Text>
        <Text $type="18" $mType="16" $textAlign="center" $color="gray600">
          실제 설문 사례를 통해 N-Survey의 다양한 활용 방식을 확인할 수 있습니다.
        </Text>
        <Box $margin="auto" $width="fit-content" $padding="64px 40px 80px" $mPadding="24px 0" $maxWidth={1600}>
          <Img desktopSrc="main5" mobileSrc="moMain5" $width="100%" />
        </Box>
      </Box>
    </Section>
  );
}
